/* eslint-disable react/prop-types */
import classes from "./about.module.scss";

import Flex from "@/components-library/layout/flex";
import ComposedViewFive from "@/composed-views/composed-view-five";
import ComposedViewOne from "@/composed-views/composed-view-one";
import ComposedViewWorkflow from "@/composed-views/composed-view-workflow";
import ComposedViewHeader from "@/composed-views/composed-view-header";

function About({ content: about }) {
  return (
    <Flex
      align="flex-start"
      className={classes.about}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={about.header.header}
        title={about.header.title}
        subTitle={about.header.subTitle}
      />
      <ComposedViewOne
        header={about.mission.header}
        title={about.mission.title}
        content={about.mission.content}
        image={about.mission.image}
        button={about.mission.button}
      />

      <ComposedViewWorkflow
        title={about.workflow.title}
        header={about.workflow.header}
        content={about.workflow.content}
        stepOne={about.workflow.stepOne}
        stepTwo={about.workflow.stepTwo}
        stepThree={about.workflow.stepThree}
        stepFour={about.workflow.stepFour}
      />

      <ComposedViewFive
        title={about.contacUs.title}
        button={about.contacUs.button}
        className={classes.contactUs}
      />
    </Flex>
  );
}

export default About;
